import {getFirstLastNames} from 'desktop/pages/checkout/components/paymentAmazonV2/libs/getFirstLastNames';
import {AmazonAddressDataType, AmazonAddressType, AmazonBuyerType} from 'types/amazonType';
import {StatesItemType} from 'types/locationType';

/**
 * Get shipping address for save
 * @param {AmazonAddressType} shippingAddress - Received shipping address
 * @param {StatesItemType | undefined} shippingRegion - Received shipping region
 * @param {AmazonBuyerType} buyer - buyer
 * @return {AmazonAddressDataType} - Shipping Object
 */
export const getShippingAddressForSave = (
    shippingAddress: AmazonAddressType,
    shippingRegion: StatesItemType | string,
    buyer: AmazonBuyerType,
): AmazonAddressDataType => ({
    address: shippingAddress.streetAddress,
    city: shippingAddress.city,
    country: shippingAddress.country,
    email: buyer?.email || shippingAddress.email,
    other: shippingAddress.streetAddress2 || '',
    phone: buyer?.phoneNumber,
    postal: shippingAddress.postalCode,
    regionID: typeof shippingRegion === 'string' ? '' : shippingRegion.id,
    state: typeof shippingRegion === 'string' ? shippingRegion : shippingRegion.label,
    ...getFirstLastNames(shippingAddress.givenName, shippingAddress.familyName),
});

/**
 * Get billing address for save
 * @param {AmazonAddressType} billingAddress - Received billing address
 * @param {StatesItemType | undefined} billingRegion - Received billing region
 * @param {AmazonBuyerType} buyer - buyer
 * @return {AmazonAddressDataType} - Billing Object
 */
export const getBillingAddressForSave = (
    billingAddress: AmazonAddressType,
    billingRegion: StatesItemType | string,
    buyer: AmazonBuyerType,
): AmazonAddressDataType => ({
    address: billingAddress.streetAddress,
    city: billingAddress.city,
    country: billingAddress.country,
    email: buyer?.email || billingAddress.email,
    other: billingAddress.streetAddress2 || '',
    phone: buyer?.phoneNumber,
    postal: billingAddress.postalCode,
    regionID: typeof billingRegion === 'string' ? '' : billingRegion.id,
    state: typeof billingRegion === 'string' ? billingRegion : billingRegion.label,
    ...getFirstLastNames(billingAddress.givenName, billingAddress.familyName),
});
